export enum TipStatus {
    Unknown = -1,
    NotReady = 0,
    NotReceived = 1,
    Received = 2,
    Skipped = 3
}